import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IFavoriteScreen } from './types';
import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';

const initialState: IFavoriteScreen = {
  favoriteItems: {},
  addRemoveFavoriteItems: {},
};

const slice = createSlice({
  name: 'favoriteSlice',
  initialState,
  reducers: {
    favoriteItemsList: (state) => {
      state.favoriteItems.status = RequestStatus.RUNNING;
    },
    favoriteItemsListSuccess(state, action) {
      state.favoriteItems.status = RequestStatus.SUCCESS;
      state.favoriteItems.data = action.payload;
    },
    favoriteItemsListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.favoriteItems.status = RequestStatus.ERROR;
      state.favoriteItems.error = action.payload;
    },
    //
    addToFavoriteItems: (state, action: PayloadAction<{ uri: any }>) => {
      state.addRemoveFavoriteItems.status = RequestStatus.RUNNING;
    },
    addToFavoriteItemsSuccess(state, action) {
      state.addRemoveFavoriteItems.status = RequestStatus.SUCCESS;
      state.favoriteItems.data = action.payload;
    },
    addToFavoriteItemsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addRemoveFavoriteItems.status = RequestStatus.ERROR;
      state.favoriteItems.error = action.payload;
    },
    //
    removeFromFavoriteList: (state, action: PayloadAction<{ uri: any }>) => {
      state.addRemoveFavoriteItems.status = RequestStatus.RUNNING;
    },
    removeFromFavoriteListSuccess(state, action) {
      state.addRemoveFavoriteItems.status = RequestStatus.SUCCESS;
      state.favoriteItems.data = action.payload;
    },
    removeFromFavoriteListFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addRemoveFavoriteItems.status = RequestStatus.ERROR;
      state.favoriteItems.error = action.payload;
    },
  },
});

export default slice.reducer;

export const {
  favoriteItemsList,
  favoriteItemsListSuccess,
  favoriteItemsListFailed,
  addToFavoriteItems,
  addToFavoriteItemsSuccess,
  addToFavoriteItemsFailed,
  removeFromFavoriteList,
  removeFromFavoriteListSuccess,
  removeFromFavoriteListFailed,
} = slice.actions;
